'use client';

import { c as _c } from "react/compiler-runtime";
import { PrizePoolHowItWorksModal as RawHowItWorksModal } from '@/components/how-it-works/prize-pool-how-it-works-modal';
import { usePrizePoolContext } from './prize-pool-context';

/**
 * Mounts the underlying `PrizePoolHowItWorksModal`, controlled by the shared
 * `<PrizePool.Provider>` context. Mount once per provider — multiple
 * `<PrizePool.HelpButton>` instances open the same modal automatically.
 */
export function PrizePoolHowItWorksModalSubcomponent() {
  const $ = _c(3);
  const {
    state: t0,
    actions: t1
  } = usePrizePoolContext();
  const {
    helpModalOpen
  } = t0;
  const {
    setHelpModalOpen
  } = t1;
  let t2;
  if ($[0] !== helpModalOpen || $[1] !== setHelpModalOpen) {
    t2 = <RawHowItWorksModal open={helpModalOpen} onOpenChange={setHelpModalOpen} />;
    $[0] = helpModalOpen;
    $[1] = setHelpModalOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}